const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const HiddenExcelQuery: any = {
    GetHiddenExcel: `${Backofficebff}/v1/hiddenexcel`,
    GetHiddenExcelTables: `${Backofficebff}/v1/hiddenexcel/tables`,
    GetHiddenExcelTableById: `${Backofficebff}/v1/hiddenexcel/tables`,
};
